<fieldset [ngModelGroup]="source">
  <h4 class="form-section">
    {{legend}} @if (canDelete) {
    <button class="btn btn-danger btn-raised pull-right" (click)="onDelete()">
      <i class="fa fa-minus-circle"></i> Elimina {{legend}}</button>
    }
  </h4>
  <div class="row">
    <div class="col-md-3">
      <div class="form-group">
        <label>Descrizione</label>
        <input type="text" class="form-control" [(ngModel)]="scadenza.Descrizione"
          name="{{namePreFix}}_{{rowNumer}}_Descrizione" required>
        </div>
      </div>

      <div class="form-group">
        <label>Data scadenza</label>
        <div class="input-group">
          <input type="text" class="form-control" name="{{namePreFix}}_{{rowNumer}}_Data" [(ngModel)]="scadenza.Data"
            ngbDatepicker #data="ngbDatepicker" required>
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" type="button" (click)="data.toggle()">
                <i class="fa fa-calendar"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label>Notifica</label>
            <select class="form-control" [(ngModel)]="scadenza.GiorniPreavviso"
              name="{{namePreFix}}_{{rowNumer}}_GiorniPreavviso" required>
              <option [value]="0">Alla scadenza</option>
              <option [value]="1">1 giorno prima</option>
              <option [value]="3">3 giorno prima</option>
              <option [value]="7">1 settimana prima</option>
              <option [value]="30">1 mese prima</option>
              <option [value]="60">2 mesi prima</option>
              <option [value]="90">3 mesi prima</option>
            </select>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Indirizzo email</label>
            <input type="email" class="form-control" [(ngModel)]="scadenza.IndirizzoEmail"
              name="{{namePreFix}}_{{rowNumer}}_IndirizzoEmail" required>
            </div>
          </div>
        </div>
      </fieldset>
